export default __webpack_public_path__ + "static/media/blog-img234.464e5770.jpg";